import {
  doc,
  onSnapshot
} from "firebase/firestore";
import { useEffect, useState } from "react";
import { db } from "../../../../firebaseConfig";

const useLessonStartStatus = (lessonId: number | string | undefined) => {
  const [isStarted, setIsStarted] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!lessonId) return;

    const docRef = doc(db, "live_sessions", String(lessonId)); // Fetch document by ID

    const unsubscribe = onSnapshot(docRef, (docSnapshot) => {
      if (docSnapshot.exists()) {
        const docData = docSnapshot.data();
        console.log("live session data:", docData);
        setIsStarted(docData.is_started);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, [lessonId]);

  return { isStarted, loading };
};

export default useLessonStartStatus;
